module.exports = __webpack_public_path__ + "static/media/loading.dd8728aa.png";